"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wwgSupportMeritIconsMapping = exports.wwgSupportMeritOptions = exports.wwgSupportMerits = exports.skillUpSupportMeritsIconMapping = exports.skillUpSupportMeritsOptions = exports.skillUpSupportMerits = void 0;
var map_1 = __importDefault(require("lodash/map"));
exports.skillUpSupportMerits = [
    'Career services',
    'Personalized placement support',
    'Instructional materials provided (uniform/computer/equipment)',
    'Childcare provided',
    'Transportation provided',
    'Food provided',
    'Job placement services',
];
exports.skillUpSupportMeritsOptions = (0, map_1.default)(exports.skillUpSupportMerits, function (merit) {
    return { value: merit, label: merit };
});
exports.skillUpSupportMeritsIconMapping = {
    'Career services': 'https://res.cloudinary.com/wherewego/image/upload/v1652997204/WWG2000%20Site%20Photos/slc15chcjqtvsya74jcn.svg',
    'Personalized placement support': 'https://res.cloudinary.com/wherewego/image/upload/v1652997223/WWG2000%20Site%20Photos/t4pduuppykaafokuaxrg.svg',
    'Instructional materials provided (uniform/computer/equipment)': 'https://res.cloudinary.com/wherewego/image/upload/v1653413006/WWG2000%20Site%20Photos/bkzcshrdheclc1m4rsac.svg',
    'Childcare provided': 'https://res.cloudinary.com/wherewego/image/upload/v1652976976/WWG2000%20Site%20Photos/nxamcgbt6t9nnajt0qex.svg',
    'Transportation provided': 'https://res.cloudinary.com/wherewego/image/upload/v1652997241/WWG2000%20Site%20Photos/zgwq9vjijsgefg5elhup.svg',
    'Food provided': 'https://res.cloudinary.com/wherewego/image/upload/v1657045600/WWG2000%20Site%20Photos/lekoaa9x7q9yizu2xzuo.svg',
    'Job placement services': 'https://res.cloudinary.com/wherewego/image/upload/v1659455481/WWG2000%20Site%20Photos/tdahf6wjetrgxlezb8oy.png',
    'Mental health services': '',
};
exports.wwgSupportMerits = [
    'Job placement',
    'Uniform provided',
    'Equipment provided',
    'Computer provided',
    'Transportation provided',
    'Food provided',
    'Childcare provided',
    'Soft-skills training',
    'Healthcare benefits',
    'Retirement benefits',
    'Housing help',
    'Alumni support',
    '1-1 mentorship',
];
exports.wwgSupportMeritOptions = (0, map_1.default)(exports.wwgSupportMerits, function (merit) {
    return {
        value: merit,
        label: merit,
    };
});
exports.wwgSupportMeritIconsMapping = {
    'Job placement': 'https://res.cloudinary.com/wherewego/image/upload/v1648268873/WWG2000%20Site%20Photos/woa7vtto6vfbh5twikeh.svg',
    'Uniform provided': 'https://res.cloudinary.com/wherewego/image/upload/v1649343101/WWG2000%20Site%20Photos/txec6qqxxf3guxmc7u80.svg',
    'Equipment provided': 'https://res.cloudinary.com/wherewego/image/upload/v1649343422/WWG2000%20Site%20Photos/xa2nua0h0awtek5ujdev.svg',
    'Computer provided': 'https://res.cloudinary.com/wherewego/image/upload/v1648269309/WWG2000%20Site%20Photos/xxh2sfzwblexc8hgnvvj.svg',
    'Transportation provided': 'https://res.cloudinary.com/wherewego/image/upload/v1648269340/WWG2000%20Site%20Photos/focjnl5rubecvcvyc6es.svg',
    'Food provided': 'https://res.cloudinary.com/wherewego/image/upload/v1649343422/WWG2000%20Site%20Photos/fapwgbvivdtzfqayoveh.svg',
    'Childcare provided': 'https://res.cloudinary.com/wherewego/image/upload/v1649343421/WWG2000%20Site%20Photos/ydui8nviziummta5mkyo.svg',
    'Soft-skills training': 'https://res.cloudinary.com/wherewego/image/upload/v1649343421/WWG2000%20Site%20Photos/gh61irnurjn9xze2u4jb.svg',
    'Healthcare benefits': 'https://res.cloudinary.com/wherewego/image/upload/v1649343420/WWG2000%20Site%20Photos/reei4trd7kzgj24buxzx.svg',
    'Retirement benefits': 'https://res.cloudinary.com/wherewego/image/upload/v1649343420/WWG2000%20Site%20Photos/uskauduerjimze6kmjfh.svg',
    'Housing help': 'https://res.cloudinary.com/wherewego/image/upload/v1649343420/WWG2000%20Site%20Photos/l5vurfqk2xilqyzzdidw.svg',
    'Alumni support': 'https://res.cloudinary.com/wherewego/image/upload/v1649343420/WWG2000%20Site%20Photos/u1qd5gczgjhxdcylhnl1.svg',
    '1-1 mentorship': 'https://res.cloudinary.com/wherewego/image/upload/v1649344772/WWG2000%20Site%20Photos/selb1fngpc1nbudcvccr.svg',
};
